<template>
  <div :class="['page', $gameTemplateStyle.createGamePage]">
    <div :class="[$globalStyle.headerContainer]">
      <HeaderActionButton
        :text="$t('back')"
        :iconLink="leftArrowIcon"
        :clickFunction="goBack"
        backBg="#000000"
        frontBg="#676767"
        textColor="#FFFFFF"
        :icon-only="isMobile"
        :button-width="isMobile ? '60px' : isTablet ? '130px' : '160px'"
      />
      <div :class="[$globalStyle.header, $globalStyle.hostHeader]">
        <div :class="$globalStyle.headerLeft">
          <div :class="$globalStyle.logoContainer">
            <img :src="saboteurLogo" alt="icon" :class="$globalStyle.headerLogo" />
            <div :class="$globalStyle.headerTitle">{{ $t('saboteur') }}</div>
          </div>
        </div>
        <div :class="$globalStyle.headerRight">
          <div v-if="realTextIndex" :class="$globalStyle.headerItem">
            <div :class="$globalStyle.headerItemLabel">{{ $t('orig-text') }}</div>
            <div style="display: flex; align-items: center; gap: 8px">
              <div
                :class="[
                  $globalStyle.headerItemText,
                  $globalStyle.headerItemHostSaboteurText,
                  !showOriginalTextInCreateGame && $globalStyle.blurredSaboteurText,
                ]"
              >
                {{ $t('text') }} {{ showOriginalTextInCreateGame ? textLabels[realTextIndex] : "X" }}
              </div>
              <HeaderItemButton
                :aria-label="
                  showOriginalTextInCreateGame
                    ? 'Hide original text'
                    : 'Show original text'
                "
                :iconLink="
                  showOriginalTextInCreateGame
                    ? secretVisibleIcon
                    : secretHideIcon
                "
                :clickFunction="toggleShowOriginalTextInCreateGame"
                backBg="#000000"
                frontBg="#676767"
                textColor="#ffc642"
                :icon-only="true"
                :button-width="'36px'"
                :button-height="'28px'"
              />
            </div>
          </div>
        </div>
      </div>
      <HeaderActionButton
        v-if="phase == 'CREATE'"
        :text="$t('reset')"
        :iconLink="resetIcon"
        :clickFunction="resetForm"
        backBg="#000000"
        frontBg="#676767"
        textColor="#FFFFFF"
        :rightIcon="true"
        :icon-only="isMobile"
        :button-width="isMobile ? '60px' : isTablet ? '130px' : '160px'"
      />
      <HeaderActionButton
        v-if="phase == 'EDIT_TEXTS'"
        :text="$t('next')"
        :iconLink="forwardArrowIcon"
        :clickFunction="nextPhase"
        backBg="#876007"
        frontBg="#ffb201"
        textColor="#FFFFFF"
        :rightIcon="true"
        :icon-only="isMobile"
        :button-width="isMobile ? '60px' : isTablet ? '160px' : '200px'"
      />
      <HeaderActionButton
        v-if="phase == 'EDIT_TITLE'"
        :text="$t('confirm')"
        :iconLink="doneIcon"
        :clickFunction="nextPhase"
        backBg="#876007"
        frontBg="#ffb201"
        textColor="#FFFFFF"
        :rightIcon="true"
        :icon-only="isMobile"
        :button-width="isMobile ? '60px' : isTablet ? '160px' : '200px'"
      />
    </div>
    <div :class="$gameTemplateStyle.bodyContainer" :style="{ paddingBottom: phase != 'CREATE' ? '20px' : '' }">
      <h1 :class="$gameTemplateStyle.bodyText" :style="{ margin: phase != 'CREATE' ? '10px 0' : '' }">
        {{ phase == "CREATE" ? $t("create-new-game") : phase == "EDIT_TEXTS" ? $t("edit-game-texts") : $t("edit-game-title") }}
      </h1>
      <div v-if="phase == 'CREATE'">
          <div :class="$gameTemplateStyle.formContainer">
          <div :class="$gameTemplateStyle.form">
            <GameSetupCoreFields
              :form="form"
              :disciplineOptions="disciplineOptions"
              :codeLanguageOptions="codeLanguageOptions"
              :formModuleClass="$gameTemplateStyle.formModule1"
              :imageUploadFailed="imageUploadFailed"
              :showTitleField="isTitleRequiredForSelectedDiscipline"
              :showImageField="!!form.discipline"
              @update:form="form = $event"
            >
              <template #after-reason-toggles>
                <UtilInput
                  :label="$t('target-audience')"
                  :iconLink="gradeIcon"
                  :placeholder="$t('select-grade')"
                  :isDropDown="true"
                  :dropdownOptions="sciArgTargetAudienceOptions"
                  :value="form.usersGrade"
                  @update:value="form.usersGrade = $event"
                />
              </template>
              <template #before-image>
                <UtilInput
                  v-if="isOriginalTextRequiredForSelectedDiscipline"
                  :label="form.discipline === 'code' ? $t('short-description') : $t('orig-text')"
                  :iconLink="newDocumentIcon"
                  :placeholder="
                    form.discipline === 'code'
                      ? $t('enter-short-description')
                      : $t('enter-original-text')
                  "
                  :value="form.originalText"
                  @update:value="form.originalText = $event"
                  :isTextArea="true"
                />
              </template>
            </GameSetupCoreFields>

            <template v-if="form.discipline === 'cyber_security'">
              <UtilInput
                :label="$t('organization')"
                :iconLink="sheetOfPaperIcon"
                :placeholder="$t('organization-desc')"
                :helperText="$t('organization-example')"
                :value="form.originalText"
                @update:value="form.originalText = $event"
                :isTextArea="true"
                :isMiniTextArea="true"
              />
            </template>
            <template v-if="form.discipline === 'science'">
              <UtilInput
                :label="$t('general-content-area')"
                :iconLink="sheetOfPaperIcon"
                :placeholder="$t('enter-general-content')"
                :helperText="$t('general-content-helper-science')"
                :value="form.sciArgContent.generalContentArea"
                @update:value="form.sciArgContent.generalContentArea = $event"
              />
              <UtilInput
                :label="$t('number-of-claims')"
                :iconLink="claimIcon"
                :placeholder="$t('select-number')"
                :isDropDown="true"
                :dropdownOptions="sciArgClaimOptions"
                :value="form.sciArgContent.numberOfClaims"
                @update:value="($event) => updateClaimsCount($event)"
              />
              <!-- <div :class="$gameTemplateStyle.formModule1">
                <UtilInput
                  label="Target Audience"
                  :iconLink="gradeIcon"
                  placeholder="Select grade"
                  :isDropDown="true"
                  :dropdownOptions="sciArgTargetAudienceOptions"
                  :value="form.sciArgContent.targetAudience"
                  @update:value="form.sciArgContent.targetAudience = $event"
                />
                <UtilInput
                  label="Number of Claims"
                  :iconLink="claimIcon"
                  placeholder="Select number"
                  :isDropDown="true"
                  :dropdownOptions="sciArgClaimOptions"
                  :value="form.sciArgContent.numberOfClaims"
                  @update:value="($event) => updateClaimsCount($event)"
                />
              </div> -->
              <div
                :class="$gameTemplateStyle.sciArgClaimModule"
                v-for="(claimItem, index) in form.sciArgContent.claims"
                :key="index"
              >
                <UtilInput
                  :label="$t('claim') + ' ' + (index + 1)"
                  :iconLink="newDocumentIcon"
                  :placeholder="$t('enter-claim')"
                  :value="form.sciArgContent.claims[index].claim"
                  @update:value="form.sciArgContent.claims[index].claim = $event"
                  :isTextArea="true"
                  :isMiniTextArea="true"
                />
                <UtilInput
                  :label="$t('evidence') + ' ' + (index + 1)"
                  :iconLink="newDocumentIcon"
                  :placeholder="$t('enter-evidence')"
                  :value="form.sciArgContent.claims[index].evidence"
                  @update:value="form.sciArgContent.claims[index].evidence = $event"
                  :isTextArea="true"
                  :isMiniTextArea="true"
                />
              </div>
            </template>
            <template v-if="form.discipline === 'history'">
              <UtilInput
                :label="$t('general-content-area')"
                :iconLink="sheetOfPaperIcon"
                :placeholder="$t('enter-general-content')"
                :helperText="$t('general-content-helper-history')"
                :value="form.sciArgContent.generalContentArea"
                @update:value="form.sciArgContent.generalContentArea = $event"
              />

              <UtilInput
                :label="$t('real-text-author')"
                :iconLink="sheetOfPaperIcon"
                :placeholder="$t('enter-author')"
                :helperText="$t('author-helper')"
                :value="form.realSourceAuthor"
                @update:value="form.realSourceAuthor = $event"
              />
              <UtilInput
                :label="$t('real-text-content')"
                :iconLink="sheetOfPaperIcon"
                :placeholder="$t('enter-real-text-content')"
                :helperText="$t('real-text-helper')"
                :value="form.realSourceText"
                @update:value="form.realSourceText = $event"
                :isTextArea="true"
              />
              <!-- <div :class="$gameTemplateStyle.formModule1">
                <UtilInput
                  label="Target Audience"
                  :iconLink="gradeIcon"
                  placeholder="Select grade"
                  :isDropDown="true"
                  :dropdownOptions="sciArgTargetAudienceOptions"
                  :value="form.sciArgContent.targetAudience"
                  @update:value="form.sciArgContent.targetAudience = $event"
                />
              </div> -->
            </template>
          </div>
          <div :class="$gameTemplateStyle.form2">
              <div v-on:click="toggleAdvanced" :class="[$gameTemplateStyle.advancedOptionsSelector]">
                <div :class="$gameTemplateStyle.advancedOptionsSelectorLabel">
                  <img :src="settingsIcon" alt="icon" class="icon" />
                  <div>{{ $t('advanced-options') }}</div>
                </div>
              <hr />
              <div :class="$gameTemplateStyle.advancedOptionsDropdown">
                <img
                  :src="sortDownIcon"
                  alt="icon"
                  class="dropdownIcon"
                  :class="{ [$gameTemplateStyle.iconRotated]: showAdvanced }"
                />
              </div>
            </div>
            <transition
              @before-enter="beforeEnter"
              @enter="enter"
              @after-enter="afterEnter"
              @before-leave="beforeLeave"
              @leave="leave"
              @after-leave="afterLeave"
            >
              <div v-show="showAdvanced" :class="$gameTemplateStyle.advancedOptionsContainer">
                <div :class="$gameTemplateStyle.advancedOptionsComponent">
                  <div :class="$gameTemplateStyle.advanceOptionsComponentLabel">{{ $t('level-of-inaccuracy') }}</div>
                  <div :class="$gameTemplateStyle.advanceoptionsComponentBox">
                    <div>
                      <UtilInput
                        :isDropDown="true"
                        size="md"
                        :label="$t('text') + ' 1'"
                        :showDropdownDefault="false"
                        :dropdownOptions="inaccuracyLevelOptions"
                        :value="form.inaccuracyLevels.text1"
                        boxBg="#ffffff"
                        @update:value="form.inaccuracyLevels.text1 = $event"
                      />
                    </div>
                    <div>
                      <UtilInput
                        :isDropDown="true"
                        size="md"
                        :label="$t('text') + ' 2'"
                        :showDropdownDefault="false"
                        :dropdownOptions="inaccuracyLevelOptions"
                        :value="form.inaccuracyLevels.text2"
                        boxBg="#ffffff"
                        @update:value="form.inaccuracyLevels.text2 = $event"
                      />
                    </div>
                    <div>
                      <UtilInput
                        :isDropDown="true"
                        size="md"
                        :label="$t('text') + ' 3'"
                        :showDropdownDefault="false"
                        :dropdownOptions="inaccuracyLevelOptions"
                        :value="form.inaccuracyLevels.text3"
                        boxBg="#ffffff"
                        @update:value="form.inaccuracyLevels.text3 = $event"
                      />
                    </div>
                  </div>
                </div>
                <div :class="$gameTemplateStyle.advancedOptionsComponent" v-if="form.discipline === 'history'">
                  <UtilInput
                    :label="$t('manual-source-type')"
                    :placeholder="$t('manual-source-type-desc')"
                    :isCheckBox="true"
                    :value="form.manualSourceType"
                    @update:value="form.manualSourceType = $event"
                  />
                  <UtilInput
                    :label="$t('manual-authors')"
                    :placeholder="$t('manual-authors-desc')"
                    :isCheckBox="true"
                    :value="form.manualAuthors"
                    @update:value="form.manualAuthors = $event"
                  />
                </div>

                <div
                  :class="$gameTemplateStyle.advancedOptionsComponent"
                  v-if="form.discipline === 'history' && form.manualSourceType"
                >
                  <div :class="$gameTemplateStyle.advanceOptionsComponentLabel">{{ $t('primary-secondary') }}</div>
                  <div :class="$gameTemplateStyle.advanceoptionsComponentBox">
                    <div>
                      <UtilInput
                        :isDropDown="true"
                        size="md"
                        :label="$t('text') + ' 1'"
                        :dropdownOptions="primarySecondaryOptions"
                        :value="form.primarySecondary.text1"
                        boxBg="#ffffff"
                        @update:value="form.primarySecondary.text1 = $event"
                      />
                    </div>
                    <div>
                      <UtilInput
                        :isDropDown="true"
                        size="md"
                        :label="$t('text') + ' 2'"
                        :dropdownOptions="primarySecondaryOptions"
                        :value="form.primarySecondary.text2"
                        boxBg="#ffffff"
                        @update:value="form.primarySecondary.text2 = $event"
                      />
                    </div>
                    <div>
                      <UtilInput
                        :isDropDown="true"
                        size="md"
                        :label="$t('text') + ' 3'"
                        :dropdownOptions="primarySecondaryOptions"
                        :value="form.primarySecondary.text3"
                        boxBg="#ffffff"
                        @update:value="form.primarySecondary.text3 = $event"
                      />
                    </div>
                  </div>
                </div>
                <div
                  :class="$gameTemplateStyle.advancedOptionsComponent"
                  v-if="form.discipline === 'history' && form.manualAuthors"
                >
                  <div :class="$gameTemplateStyle.advanceOptionsComponentLabel">{{ $t('text-authors') }}</div>
                  <div :class="$gameTemplateStyle.advanceoptionsComponentBox">
                    <div>
                      <UtilInput
                        :label="$t('text') + ' 1'"
                        :iconLink="sheetOfPaperIcon"
                        size="sm"
                        :placeholder="$t('enter-author-text1')"
                        :value="form.sources.text1"
                        boxBg="#ffffff"
                        @update:value="form.sources.text1 = $event"
                      />
                    </div>
                    <div>
                      <UtilInput
                        :label="$t('text') + ' 2'"
                        :iconLink="sheetOfPaperIcon"
                        size="sm"
                        :placeholder="$t('enter-author-text2')"
                        :value="form.sources.text2"
                        boxBg="#ffffff"
                        @update:value="form.sources.text2 = $event"
                      />
                    </div>
                    <div>
                      <UtilInput
                        :label="$t('text') + ' 3'"
                        :iconLink="sheetOfPaperIcon"
                        size="sm"
                        :placeholder="$t('enter-author-text3')"
                        :value="form.sources.text3"
                        boxBg="#ffffff"
                        @update:value="form.sources.text3 = $event"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="false" :class="$gameTemplateStyle.advancedOptionsComponent">
                  <UtilInput
                    :label="$t('llm')"
                    :iconLink="aiIcon"
                    :isDropDown="true"
                    :showDropdownDefault="false"
                    :dropdownOptions="llmOptions"
                    :value="form.llm"
                    @update:value="form.llm = $event"
                  />
                </div>
              </div>
            </transition>
          </div>
          <div :class="$gameTemplateStyle.visibilitySection">
            <div :class="$gameTemplateStyle.visibilityDefaultText">
              {{ form.visibility === "private" ? $t("visibility-private-default") : $t("visibility-public-default") }}
            </div>
            <button type="button" :class="$gameTemplateStyle.visibilityButton" @click="form.visibility = form.visibility === 'private' ? 'public' : 'private'">
              {{ $t("change-visibility") }}
            </button>
          </div>
        </div>
        <div :class="$gameTemplateStyle.ctaContainer">
          <UtilButton
            :text="$t('create')"
            :clickFunction="nextPhase"
            size="lg"
            frontBg="#3F72AF"
            backBg="#112D4E"
            textColor="#FFFFFF"
            :button-width="isMobile ? '200px' : isTablet ? '220px' : '240px'"
          />
        </div>
      </div>
      <div v-if="phase == 'EDIT_TEXTS'" :class="$gameTemplateStyle.editTextContainer">
        <GameTextsBox
          :texts="game.texts"
          :discipline="form.discipline"
          :codeLanguage="form.codeLanguage"
          :textTitle="game.textTitle || form.title"
          @update-texts="updateGameTexts"
          :editTexts="true"
          :showTextsOnly="true"
          :realTextId="displayCreateGameRealTextId"
          :realTextLabel="displayCreateGameRealTextLabel"
          :imageUrl="game?.imageUrl ?? ''"
          :showImageButton="true"
        />
      </div>
      <div v-if="phase == 'EDIT_TITLE'" :class="$gameTemplateStyle.editTitleContainer">
        <div :class="$gameTemplateStyle.titleInputContainer">
          <input type="text" v-model="this.game.textTitle" :placeholder="$t('enter-title')" />
        </div>
      </div>
    </div>
    <div v-if="isLoading" :class="['loader-container']">
      <img :src="hostLoaderGif" alt="loader-gif" class="loader-gif" />
      <!-- <div :class="['loader']">Loading ...</div> -->
    </div>
  </div>
</template>

<script>
import styles from "@/css/CreateGameView.module.css";
import gameTemplateStyles from "@/css/GameViewTemplate.module.css";
import globalStyles from "@/css/global.module.css";
import UtilButton from "@/components/util/UtilButton.vue";
import GameTextsBox from "@/components/playGame/GameTextsBox.vue";
import SaboteurLogo from "../assets/saboteur-logo.svg";
import LeftArrowIcon from "@/assets/icons/left-arrow.svg";
import ResetIcon from "@/assets/icons/reset.svg";
import ForwardArrowIcon from "@/assets/icons/forward-arrow.svg";
import UtilInput from "@/components/util/UtilInput.vue";
import DetectiveHatIcon from "@/assets/icons/detective-hat.svg";
import UsersIcon from "@/assets/icons/users.svg";
import EmptyHourglassIcon from "@/assets/icons/empty-hourglass.svg";
import CategorizeIcon from "@/assets/icons/categorize.svg";
import NewDocumentIcon from "@/assets/icons/new-document.svg";
import SheetOfPaperIcon from "@/assets/icons/sheet-of-paper.svg";
import SourceCodeIcon from "@/assets/icons/source-code.svg";
import AIIcon from "@/assets/icons/ai.svg";
import SettingsIcon from "@/assets/icons/settings-blue.svg";
import SortDownIcon from "@/assets/icons/sort-down-blue.svg";
import DoneIcon from "@/assets/icons/done.svg";
import ClaimIcon from "@/assets/icons/claim.svg";
import GradeIcon from "@/assets/icons/graduation-cap.svg";
import HostLoaderGif from "@/assets/gifs/host-loader.svg";
import ImageIcon from "@/assets/icons/image.svg";
import { toast } from "vue3-toastify";
import gameService from "@/services/game.service";
import { useGameStore } from "@/stores/gameStore";
import BrokenImageIcon from "@/assets/icons/broken-image.svg";
import SecretVisibleIcon from "@/assets/icons/secret-visible.svg";
import SecretHideIcon from "@/assets/icons/secret-hide.svg";
import {
  codeLanguageOptions,
  disciplineOptions,
  inaccuracyLevelOptions,
  primarySecondaryOptions,
  llmOptions,
  originalTextDisciplineIds,
  sciArgClaimOptions,
  sciArgTargetAudienceOptions,
  textLabels,
  titleDisciplineIds,
} from "@/utils/data";
import useDeviceType from "@/utils/useDeviceType";
import HeaderActionButton from "@/components/buttons/HeaderActionButton.vue";
import HeaderItemButton from "@/components/buttons/HeaderItemButton.vue";
import GameSetupCoreFields from "@/components/util/GameSetupCoreFields.vue";
import { createCreateGameFormDefaults } from "@/utils/gameForm";
import { validateSharedGameForm } from "@/utils/gameFormValidation";

const device = useDeviceType();

export default {
  name: "CreateGameView",
  components: {
    UtilButton,
    UtilInput,
    GameTextsBox,
    HeaderActionButton,
    HeaderItemButton,
    GameSetupCoreFields,
  },
  data() {
    return {
      saboteurLogo: SaboteurLogo,
      leftArrowIcon: LeftArrowIcon,
      resetIcon: ResetIcon,
      forwardArrowIcon: ForwardArrowIcon,
      detectiveHatIcon: DetectiveHatIcon,
      usersIcon: UsersIcon,
      emptyHourglassIcon: EmptyHourglassIcon,
      categorizeIcon: CategorizeIcon,
      newDocumentIcon: NewDocumentIcon,
      sheetOfPaperIcon: SheetOfPaperIcon,
      sourceCodeIcon: SourceCodeIcon,
      aiIcon: AIIcon,
      settingsIcon: SettingsIcon,
      sortDownIcon: SortDownIcon,
      doneIcon: DoneIcon,
      claimIcon: ClaimIcon,
      gradeIcon: GradeIcon,
      imageIcon: ImageIcon,
      secretVisibleIcon: SecretVisibleIcon,
      secretHideIcon: SecretHideIcon,
      selectedFileName: "",
      imageUploadFailed: false,
      brokenImageIcon: BrokenImageIcon,
      hostLoaderGif: HostLoaderGif,
      disciplineOptions: disciplineOptions,
      codeLanguageOptions: codeLanguageOptions,
      inaccuracyLevelOptions: inaccuracyLevelOptions,
      primarySecondaryOptions: primarySecondaryOptions,
      llmOptions: llmOptions,
      sciArgTargetAudienceOptions: sciArgTargetAudienceOptions,
      sciArgClaimOptions: sciArgClaimOptions,
      titleDisciplineIds: titleDisciplineIds,
      originalTextDisciplineIds: originalTextDisciplineIds,
      showAdvanced: false,
      form: createCreateGameFormDefaults(),
      isLoading: false,
      gameTextEdit: false,
      phase: "CREATE", // CREATE, EDIT_TEXTS, EDIT_TITLE
      game: {},
      fbGameDocId: "",
      playerId: null,
      userAvatarUrl: "",
      joinCode: "",
      realTextIndex: null,
      showOriginalTextInCreateGame: false,
      textLabels: textLabels,
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $gameTemplateStyle() {
      return gameTemplateStyles;
    },
    $globalStyle() {
      return globalStyles;
    },
    width() {
      return device.width.value;
    },
    height() {
      return device.height.value;
    },
    isMobile() {
      return device.isMobile.value;
    },
    isTablet() {
      return device.isTablet.value;
    },
    isDesktop() {
      return device.isDesktop.value;
    },
    selectedDisciplineId() {
      return this.disciplineOptions.find(
        (option) => option.selectionValue === this.form.discipline,
      )?.id;
    },
    isTitleRequiredForSelectedDiscipline() {
      return this.titleDisciplineIds.includes(this.selectedDisciplineId);
    },
    isOriginalTextRequiredForSelectedDiscipline() {
      return this.originalTextDisciplineIds.includes(this.selectedDisciplineId);
    },
    displayCreateGameRealTextId() {
      return this.showOriginalTextInCreateGame
        ? this.game.realTextId || null
        : null;
    },
    displayCreateGameRealTextLabel() {
      return this.showOriginalTextInCreateGame
        ? this.game.realTextLabel || ""
        : "";
    },
  },
  watch: {
    "form.discipline"(newVal) {
      if (!newVal) return;
      if (this.form.imageUrl && this.form.imageUrl.startsWith("blob:")) {
        URL.revokeObjectURL(this.form.imageUrl);
      }

      this.form.imageFile = null;
      this.form.imageUrl = "";
      this.form.imageUploading = false;
    },
  },
  methods: {
    getDefaultForm() {
      return {
        hostName: "",
        allowedPlayers: null,
        groupLimit: null,
        readingTime: null,
        discussionTime: null,
        title: "",
        discipline: "",
        codeLanguage: "",
        originalText: "",
        preliminaryReason: true,
        finalReason: true,
        manualSourceType: false,
        manualAuthors: false,
        llm: "Gemini", // @TODO: automate this and other constants later
        inaccuracyLevels: {
          text1: "Medium",
          text2: "Medium",
          text3: "Medium",
        },
      };
    },
    resetForm() {
      // console.log("Resetting form...");
      const defaultForm = this.getDefaultForm();
      Object.keys(this.form).forEach((key) => {
        if (typeof defaultForm[key] === "object" && defaultForm[key] !== null) {
          this.form[key] = JSON.parse(JSON.stringify(defaultForm[key]));
        } else {
          this.form[key] = defaultForm[key];
        }
      });
      this.showOriginalTextInCreateGame = false;
    },
    toggleShowOriginalTextInCreateGame() {
      this.showOriginalTextInCreateGame = !this.showOriginalTextInCreateGame;
    },

    goBack() {
      // console.log("go back clicked");
      // console.log("this.phase: ", this.phase);
      // this.$router.push({ name: "home", params: { userId: 123 } });
      if (this.phase == "CREATE") {
        this.$router.push({ name: "home" });
      } else if (this.phase == "EDIT_TEXTS") {
        // this.resetForm();
        this.phase = "CREATE";
      } else if (this.phase == "EDIT_TITLE") {
        this.phase = "EDIT_TEXTS";
      }
    },
    toggleAdvanced() {
      this.showAdvanced = !this.showAdvanced;
    },
    // Transition Hooks
    beforeEnter(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    },
    enter(el, done) {
      el.style.transition = "all 0.3s ease-in-out";
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";

      el.addEventListener("transitionend", function handler(e) {
        if (e.target === el) {
          el.removeEventListener("transitionend", handler);
          done();
        }
      });
    },
    afterEnter(el) {
      el.style.height = "auto";
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    leave(el, done) {
      el.style.transition = "all 0.3s ease-in-out";
      el.style.height = "0";
      el.style.opacity = "0";

      el.addEventListener("transitionend", function handler(e) {
        if (e.target === el) {
          el.removeEventListener("transitionend", handler);
          done();
        }
      });
    },
    afterLeave(el) {
      el.style.height = "";
      el.style.opacity = "";
    },
    async nextPhase() {
      if (this.phase == "CREATE") {
        // create game
        const createRes = await this.createGame();
        // console.log("before api call and update");

        if (createRes) {
          this.phase = "EDIT_TEXTS";
        }
      } else if (this.phase == "EDIT_TEXTS") {
        // validate game texts
        let gameTextsError = false;
        this.game.texts.forEach((text) => {
          if (!text.content) {
            gameTextsError = true;
            toast(`Text ${text.label} should not be empty!`, {
              type: "error",
            });
          }
        });

        if (gameTextsError) {
          return false;
        }

        this.phase = "EDIT_TITLE";
      } else if (this.phase == "EDIT_TITLE") {
        // validate game title
        if (!this.game.textTitle) {
          toast(this.$t("error-game-title-empty"), {
            type: "error",
          });

          return false;
        }

        // make edit texts API call
        await this.submitTextConfirm();
      }
    },
    validateCreateGameForm() {
      const notify = (message) => {
        toast(message, { type: "error" });
      };

      if (
        !validateSharedGameForm({
          form: this.form,
          t: (key) => this.$t(key),
          notify,
          requireDiscipline: true,
          requireTitle: this.isTitleRequiredForSelectedDiscipline,
        })
      ) {
        return false;
      }

      if (!this.form.usersGrade) {
        toast(this.$t("error-target-grade"), {
          type: "error",
        });

        return false;
      }

      if (this.isOriginalTextRequiredForSelectedDiscipline && !this.form.originalText) {
        // console.log("in original text disciplines");
        if (this.form.discipline === "code") {
          toast(this.$t("error-short-description"), {
            type: "error",
          });
        } else {
          toast(this.$t("error-original-text"), {
            type: "error",
          });
        }

        return false;
      }

      if (this.form.discipline == "science") {
        if (!this.form.sciArgContent.generalContentArea) {
          toast(this.$t("error-general-content"), {
            type: "error",
          });

          return false;
        }

        // if (!this.form.sciArgContent.targetAudience) {
        //   toast("Please select the grade of target audience.", {
        //     type: "error",
        //   });

        //   return false;
        // }

        for (let i = 0; i < parseInt(this.form.sciArgContent.numberOfClaims); i++) {
          if (!this.form.sciArgContent.claims[i].claim) {
            toast(this.$t("error-claim") + " " + (i + 1) + ".", {
              type: "error",
            });

            return false;
          }

          if (!this.form.sciArgContent.claims[i].evidence) {
            toast(this.$t("error-evidence") + " " + (i + 1) + ".", {
              type: "error",
            });

            return false;
          }
        }
      }

      // @see: advanced options are mandatory. hence validation is not needed

      return true;
    },
    async createGame() {
      // console.log("Create Game clicked");
      // console.log("this.form: ", this.form);
      // check inputs provided
      if (!this.validateCreateGameForm()) {
        return false;
      }

      try {
        this.isLoading = true;

        // proceed to create game
        // console.log("make the api call!");

        let combinedText = `Original Text: ${this.form.originalText}, Language: ${this.form.codeLanguage}, Discipline: ${this.form.discipline}`; // @TODO: this should be cleaned
        // console.log("combinedText: ", combinedText);

        // add claims according to backend
        let claimsAndEvidence = {};
        if (this.form.sciArgContent.claims) {
          this.form.sciArgContent.claims.forEach((item, index) => {
            claimsAndEvidence["claim" + (index + 1)] = item.claim;
            claimsAndEvidence["evidence" + (index + 1)] = item.evidence;
          });
        }

        let newGame = await gameService.createNewGame({
          hostId: this.form.hostName,
          joinCode: "",
          playerNum: this.form.allowedPlayers,
          groupLimit: this.form.groupLimit,
          readingTime: this.form.readingTime,
          discussionTime: this.form.discussionTime,
          textTitle: this.form.title ? this.form.title : "",
          targetAudience: this.form.usersGrade,
          discipline: this.form.discipline,
          advancedOptions: this.form.inaccuracyLevels,
          originalText: combinedText,
          language: this.form.codeLanguage ? this.form.codeLanguage : "",
          uniquePlayerId: 0,
          uniqueTextId: [],
          sortedTextVotes: {},
          sortedSaboteurVotes: {},
          messages: [],
          llm: this.form.llm,
          enableVoteReason: this.form.finalReason ? 1 : 0,
          enablePreliminaryVoteReason: this.form.preliminaryReason ? 1 : 0,
          contentArea: this.form.sciArgContent?.generalContentArea,
          numberOfClaims: this.form.sciArgContent?.numberOfClaims,
          claimsAndEvidence: claimsAndEvidence,
          sources: this.form.sources,
          primarySecondary: this.form.primarySecondary,
          realSourceAuthor: this.form.realSourceAuthor,
          realSourceText: this.form.realSourceText,
          imageUrl: null,
          isPublic: this.form.visibility === "public" ? 1 : 0,
        });
        if (newGame.rejoinToken) {
          localStorage.setItem(
            `rejoinToken_${newGame.joinCode}`,
            newGame.rejoinToken
          );
        }
        if (newGame && this.form.imageFile) {
          this.form.imageUploading = true;
          this.imageUploadFailed = false;

          try {
            const res = await gameService.uploadGameImage(
              newGame.gameId,
              this.form.imageFile,
            );
            const s3Url = res?.image_url;

            if (!s3Url)
              throw new Error("uploadGameImage returned no image_url");

            newGame.imageUrl = s3Url;
            this.form.imageUrl = s3Url;
            this.form.imageFile = null;
          } catch (e) {
            console.error("uploadGameImage failed:", e);

            // show backend error text (source of truth)
            const detail = e?.response?.data?.detail;
            toast(detail || this.$t("image-upload-failed"), {
              type: "error",
            });

            this.imageUploadFailed = true;
          } finally {
            this.form.imageUploading = false;
          }
        }
        this.userAvatarUrl = newGame.userAvatarUrl;

        newGame.texts = newGame.texts.map((text, index) => {
          return {
            ...text,
            id: parseInt(newGame.textOrder[index]),
            label: this.textLabels[index + 1],
            content: this.getFilteredText(text.content),
          };
        });

        this.game = newGame;
        // console.log("game after created: ", newGame);

        // this.username = hostUsername;
        this.fbGameDocId = newGame.fbGameDocId;

        this.fbHost = {
          id: parseInt(newGame.uniquePlayerId),
          username: this.form.hostName,
        };

        this.playerId = parseInt(newGame.uniquePlayerId);
        this.joinCode = newGame.joinCode;

        // Parse the textOrder and assign IDs to texts
        let textOrderIds = newGame.textOrder
          .split(", ")
          .filter((id) => id !== "")
          .map(Number);

        this.game.texts = this.game.texts.map((text, index) => {
          return {
            ...text,
            id: textOrderIds[index], // Assign the corresponding ID from textOrder
            voted: 0, // Initialize voted to 0
          };
        });
        // console.log("Texts with IDs: ", this.game.texts);

        for (var i = 0; i < this.game.texts.length; i++) {
          if (this.game.texts[i]["isReal"] == true) {
            this.realTextIndex = i + 1;
            this.game.realTextId = textOrderIds[i];
            this.game.realTextLabel = this.textLabels[i + 1];
          }
        }

        this.showOriginalTextInCreateGame = false;

        // console.log(this.game);

        // this.gameTextEdit = true;
        return true;
      } catch (error) {
        console.error("Error: ", error);

        // New structured error: { success:false, error:{ text, message } }
        const apiErr = error?.response?.data?.error;
        const code = apiErr?.text;
        const msg = apiErr?.message;

        // Case 1: not logged in / missing token / invalid token
        if (code === "MISSING_TOKEN" || code === "INVALID_TOKEN") {
          toast(this.$t("login-required"), { type: "error" });
          return false;
        }

        // Case 2: logged in but not host
        if (code === "NOT_HOST") {
          toast(this.$t("host-required"), { type: "error" });
          return false;
        }

        // Fallback
        toast(msg || this.$t("unexpected-error"), {
          type: "error",
        });
        return false;
      } finally {
        this.isLoading = false;
      }
    },
    getFilteredText(orgText) {
      const pattern = /Original Text: (.*), Language: (.*), Discipline: (.*)/s; // 's' flag to handle multiline Original Text
      const match = orgText.match(pattern);
      if (match) {
        return match[1];
      } else {
        return orgText;
      }
    },
    updateGameTexts(updatedTexts) {
      // Update texts when edited in GameTextsBox
      this.game.texts = updatedTexts;
    },
    async submitTextConfirm() {
      // this.game.texts.map((text, index) => {
      //   console.log("text ", index + 1, ": ", text.content);
      // });
      try {
        this.isLoading = true;

        // console.log("game texts before confirming them: ", this.game.texts);
        // Make API call to update game texts
        await gameService.updateGameTexts(this.game.gameId, this.game.texts, this.game.textTitle);

        let combinedText = `Original Text: ${this.form.originalText}, Language: ${this.form.codeLanguage}, Discipline: ${this.form.discipline}`; // @TODO: this should be cleaned
        let storedToken = localStorage.getItem(`rejoinToken_${this.game.joinCode}`);
        // Re-fetch the game data after updating texts
       // console.log("CHECK BEFORE STORE:", gameData.enablePreliminaryVoteReason);
        let gameData = await gameService.joinGame({
          hostId: this.form.hostName,
          joinCode: this.game.joinCode,
          rejoinToken: storedToken,
          playerNum: this.form.allowedPlayers,
          groupLimit: this.form.groupLimit,
          readingTime: this.form.readingTime,
          discussionTime: this.form.discussionTime,
          textTitle: this.form.title ? this.form.title : "",
          discipline: this.form.discipline,
          advancedOptions: this.form.inaccuracyLevels,
          originalText: combinedText,
          language: this.form.codeLanguage ? this.form.codeLanguage : "",
          uniquePlayerId: this.game.uniquePlayerId,
          uniqueTextId: [],
          sortedTextVotes: {},
          sortedSaboteurVotes: {},
          messages: [],
          llm: this.form.llm,
          enablePreliminaryVoteReason: this.form.preliminaryReason ? 1 : 0,
          enableFinalReason: this.form.finalReason ? 1 : 0,
          playerId: this.form.hostName,
          players: [],
          imageUrl: this.game?.imageUrl ?? null,
        });
        this.game = gameData;
        localStorage.setItem("lastJoinCode", gameData.joinCode);
        localStorage.setItem("lastPlayerName", this.form.hostName);

      if (gameData.rejoinToken) {
        localStorage.setItem(
          `rejoinToken_${gameData.joinCode}`,
          JSON.stringify({
            token: gameData.rejoinToken,
            createdAt: Date.now(),
          })
        );
      }
        // console.log("API gameData:", gameData);
        // console.log("game after joining: ", gameData);

        // modify texts
        let realTextId = null;
        let realTextLabel = "";
        let modifiedTexts = gameData.texts.map((text, index) => {
          if (text.isReal) {
            realTextId = parseInt(gameData.uniqueTextId[index]);
            realTextLabel = this.textLabels[index + 1];
          }

          return {
            id: gameData.uniqueTextId[index],
            label: this.textLabels[index + 1],
            content: text.content,
          };
        });

        // Save game data in Pinia store
        let gameStoreData = {
          host: { id: this.game.uniquePlayerId, name: this.form.hostName },
          joinCode: this.game.joinCode,
          allowedPlayers: this.form.allowedPlayers,
          groupLimit: Number(this.form.groupLimit),
          readingTime: this.form.readingTime,
          discussionTime: this.form.discussionTime,
          textTitle: gameData.textTitle,
          discipline: this.form.discipline,
          inaccuracyLevels: this.form.inaccuracyLevels,
          originalText: this.form.originalText,
          combinedText: combinedText,
          codeLanguage: this.form.codeLanguage ? this.form.codeLanguage : "",
          llm: this.form.llm,
          enablePreliminaryVoteReason: this.form.preliminaryReason ? 1 : 0,
          enableVoteReason: this.form.finalReason ? 1 : 0,
          fbGameDocId: gameData.fbGameDocId,
          gameId: gameData.gameId,
          uniqueTextId: gameData.uniqueTextId,
          texts: modifiedTexts,
          realTextId: realTextId,
          realTextLabel: realTextLabel,
          imageUrl: gameData.imageUrl ?? this.form.imageUrl ?? null,
          phase: "JOIN",
        };
        // console.log("gameStoreData: ", gameStoreData);
        const gameStore = useGameStore();
        gameStore.setGameData(
          gameStoreData,
          true,
          {
            id: this.game.uniquePlayerId,
            name: this.form.hostName,
            avatar: this.userAvatarUrl,
          },
          false,
        ); // Set `isHost` to true for the host
        sessionStorage.setItem("isReconnectFlow", "false");
        // Navigate to PlayGameView
        this.$router.push({name: "play-game"});
      } catch (error) {
        console.error("Error: ", error);
        toast(this.$t("unexpected-error"), {
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },
    updateClaimsCount(event) {
      // console.log("updateClaimsCount event: ", event);
      this.form.sciArgContent.numberOfClaims = event;

      var tempClaims = [];

      for (let i = 0; i < parseInt(event); i++) {
        if (this.form.sciArgContent.claims[i]) {
          tempClaims.push(this.form.sciArgContent.claims[i]);
        } else {
          tempClaims.push({ claim: "", evidence: "" });
        }
      }

      this.form.sciArgContent.claims = tempClaims;
    },
  },
};
</script>

<style scoped></style>
